// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-467009f5]::-webkit-outer-spin-button,\ninput[data-v-467009f5]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-467009f5] {\n  -moz-appearance: textfield;\n}\n[data-v-467009f5] .composer-editor {\n  max-height: 300px;\n  height: 200px;\n}", ""]);
// Exports
module.exports = exports;
